module.exports = __webpack_public_path__ + "public/images/overview/Chapikovskaya.acd0ffd64fb390c5224403dc623598a2.png";